import React, { useState } from "react";
import { View,  TouchableOpacity, } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { COLORS } from '../constant';
import CImage from './CImage';
import CText from './CText';
import RootNavigation from "../utilities/RootNavigation";


export default function Sidebar() {
    const styles = useStyles();
    const deviceSize = useDeviceSize();
    const [isShowSidebar, setIsShowSidebar] = useState(false);
    let isSmallDevice = deviceSize === "small" || deviceSize === "extrasmall" ? true : false;

    const onNavigate = (screen) => {
        RootNavigation.navigate(screen);
        global.activeScreen = screen;
        setIsShowSidebar(!isShowSidebar)
    }
    const onNavigateMobile = (screen) => {
        RootNavigation.navigate(screen);
        global.activeScreen = screen;
        setIsShowSidebar(!isShowSidebar)
        global.sidebarHide = false
    }
    const activeScreen = global.activeScreen;
    const isDashboard =  global.activeScreen?.toLowerCase() == "dashboard" ||  global.activeScreen?.toLowerCase() == "home"
    const isProfile =  global.activeScreen?.toLowerCase() == "profile"
    const isStatement =  global.activeScreen?.toLowerCase() == "statement"
    const isRecharge =  global.activeScreen?.toLowerCase() == "recharge"
    const isTransfer =  global.activeScreen?.toLowerCase() == "transfer"
    const isHelp =  global.activeScreen?.toLowerCase() == "help"
    const isDispute =  global.activeScreen?.toLowerCase() == "dispute"
    const isOtherServices =  global.activeScreen?.toLowerCase() == "otherservices"
    const isServiceRequest =  global.activeScreen?.toLowerCase() == "servicerequest"  


    return (
        
        <View style={[styles.container,{display:global.sidebarHide == false ? 'none' :'flex'}]}>
            <TouchableOpacity
                onPress={() => {
                   isSmallDevice ? onNavigateMobile("Dashboard") : onNavigate("Dashboard")
                }}
                style={[styles.navItem,
                { backgroundColor: isDashboard  ? "#9c1d25" : "#fff", },
                ]}>
                {isDashboard ? <CImage.dashboardIconActive></CImage.dashboardIconActive> : 
                <CImage.dashboardIcon></CImage.dashboardIcon>}
                <CText.sideNavText style={{ color: isDashboard ? '#fff' : '#a0a0a0' }}>{'Dashboard'}</CText.sideNavText>
            </TouchableOpacity>
            <TouchableOpacity
                onPress={() => {
                    isSmallDevice ? onNavigateMobile("Profile") : onNavigate("Profile")
                }}
                style={[styles.navItem,
                { backgroundColor: isProfile ? "#9c1d25" : "#fff", },
                ]}
            >
                {isProfile ? <CImage.profileIconActive></CImage.profileIconActive> : 
                <CImage.profileIcon></CImage.profileIcon>}
                <CText.sideNavText style={{ color: isProfile ? '#fff' : '#a0a0a0' }}>{'Profile'}</CText.sideNavText>
            </TouchableOpacity>
            <TouchableOpacity
                onPress={() => {
                    isSmallDevice ? onNavigateMobile("Statement") : onNavigate("Statement")
                }}
                style={[styles.navItem,
                { backgroundColor: isStatement ? "#9c1d25" : "#fff", },
                ]}
            >
                {isStatement ? <CImage.statementIconActive></CImage.statementIconActive> : 
                <CImage.statementIcon></CImage.statementIcon>}
                <CText.sideNavText style={{ color: isStatement ? '#fff' : '#a0a0a0' }}>{'Statement'}</CText.sideNavText>
            </TouchableOpacity>
            <TouchableOpacity 
            onPress={() => {
                isSmallDevice ? onNavigateMobile("Recharge") : onNavigate("Recharge")
            }}
                style={[styles.navItem,
                { backgroundColor: isRecharge ? "#9c1d25" : "#fff", },
                ]}
            >
                {isRecharge ? <CImage.rechargeIconActive></CImage.rechargeIconActive> : 
                <CImage.rechargeIcon></CImage.rechargeIcon>}
                <CText.sideNavText style={{ color: isRecharge ? '#fff' : '#a0a0a0' }}>{'Recharge'}</CText.sideNavText>
            </TouchableOpacity>
            <TouchableOpacity 
            onPress={() => {
                isSmallDevice ? onNavigateMobile("Transfer") : onNavigate("Transfer")
            }}
                style={[styles.navItem,
                { backgroundColor: isTransfer ? "#9c1d25" : "#fff", },
                ]}
            >
                {isTransfer ? <CImage.transferIconActive></CImage.transferIconActive> : 
                <CImage.transferIcon></CImage.transferIcon>}
                <CText.sideNavText style={{ color: isTransfer ? '#fff' : '#a0a0a0' }}>{'Transfer'}</CText.sideNavText>
            </TouchableOpacity>
            <TouchableOpacity 
            onPress={() => {
                isSmallDevice ? onNavigateMobile("Help") : onNavigate("Help")
            }}
                style={[styles.navItem,
                { backgroundColor: isHelp ? "#9c1d25" : "#fff", },
                ]}
            >
                {isHelp ? <CImage.helpIconActive></CImage.helpIconActive> : 
                <CImage.helpIcon></CImage.helpIcon>}
                <CText.sideNavText style={{ color: isHelp ? '#fff' : '#a0a0a0' }}>{'Help'}</CText.sideNavText>
            </TouchableOpacity>
            <TouchableOpacity 
            onPress={() => {
                isSmallDevice ? onNavigateMobile("Dispute") : onNavigate("Dispute")
            }}
                style={[styles.navItem,
                { backgroundColor: isDispute ? "#9c1d25" : "#fff", },
                ]}
            >
                {isDispute ? <CImage.disputeIconActive></CImage.disputeIconActive> : 
                <CImage.disputeIcon></CImage.disputeIcon>}
                <CText.sideNavText style={{ color: isDispute ? '#fff' : '#a0a0a0' }}>{'Disputes'}</CText.sideNavText>
            </TouchableOpacity>
            <TouchableOpacity 
            onPress={() => {
                isSmallDevice ? onNavigateMobile("OtherServices/insurance") : onNavigate("OtherServices/insurance")
            }}
                style={[styles.navItem,
                { backgroundColor: isOtherServices ? "#9c1d25" : "#fff", },
                ]}
            >
                {isOtherServices ? <CImage.otherServiceIconActive></CImage.otherServiceIconActive> : 
                <CImage.otherServiceIcon></CImage.otherServiceIcon>}
                <CText.sideNavText style={{ color: isOtherServices ? '#fff' : '#a0a0a0' }}>{'Other Services'}</CText.sideNavText>
            </TouchableOpacity>
            <TouchableOpacity 
            onPress={() => {
                isSmallDevice ? onNavigateMobile("ServiceRequest") : onNavigate("ServiceRequest")
            }}
                style={[styles.navItem,
                { backgroundColor: isServiceRequest ? "#9c1d25" : "#fff", },
                ]}
            >
                {isServiceRequest ? <CImage.disputeIconActive></CImage.disputeIconActive> :
                 <CImage.disputeIcon></CImage.disputeIcon>}
                <CText.sideNavText style={{ color: isServiceRequest ? '#fff' : '#a0a0a0' }}>{'Service Req.'}</CText.sideNavText>
            </TouchableOpacity>
        </View>
    )
}


const useStyles = CreateResponsiveStyle(
    {
        container: {
            width:  140,
            backgroundColor: COLORS.white,
            borderRadius: 12,
            paddingVertical: 10,
            height:700
            
        },
        navItem: {
            alignItems: 'center',
            paddingVertical: 12,
            marginHorizontal: 14,
            borderRadius: 12,
            textAlign: 'center',
        }
    },

    {
        [DEVICE_SIZES.LG]: {

        },
        [DEVICE_SIZES.MD]: {

        },
        [DEVICE_SIZES.SM]: {

        },
        [DEVICE_SIZES.XS]: {
            container: {
                width: 100,
                position: 'absolute',
                top: 0,
                left: 1,
                zIndex: 99,
            },
        },
    }
);